<template>
    <div>
<!--        <notifications position="top center" width="80%"/>-->

        <np-application-breadcrumb :mode="'arrowcrumb'" :crumbs="tabsToRender"></np-application-breadcrumb>
        <div class="row">
            <div class="col-12">
                <router-view></router-view>
            </div>

        </div>
    </div>
</template>

<script>
    import applicationMixin from "../../utils/application-mixin";
    import navigationMixin from "../../utils/navigation-mixin";
    import NPAppBreadcrumb from "../../components/np-application-breadcrumb.vue";
    import {NPSkeleton} from "netpify/components";
    import * as types from "../../stores/constants";
    import {mapActions} from "pinia";
    import useApplicationStore from "../../stores/application_module";

    export default {
        name: "ApplicationView",
        mixins: [applicationMixin, navigationMixin],
        components: {
            'np-application-breadcrumb': NPAppBreadcrumb,
            'np-skeleton': NPSkeleton,
        },
        data() {
            return {
                application: [],
            }
        },
        mounted() {
            if (!this.objectIsNotEmpty(this.parameters)){
                // I just made this async - nothing else :)
                this[types.FETCH_APPLICATION_PARAMETERS]().then(obj => {

                    //get quote data
                    if ((!this.quote.hasOwnProperty('quote_external_id') || this.quote.quote_external_id === '')
                        && (!!this.$route.params.quote_id || !!this.merchant_user_access.quote)) {
                        this.fetchQuoteData(this.$route.params.quote_id);
                    }

                    // }else{
                    //     this.setQuoteRootPath(this.$route.params.quote_id, 'view')
                    // }
                }).then(res => {

                    //get application data
                    if (!this.merchant.hasOwnProperty('application_reference') || this.merchant.application_reference === '') {
                        this.fetchApplicationData(this.$route.params.application_reference)
                    }else{
                        //this is pushing undefined to the route.
                        // this.setApplicationRootPath(this.merchant.application_reference);
                    }

                });
            }

            //TODO turn theses into async fetches

        },
        created() {

        },
        computed: {
            quote_id: function () {
                return this.$route.params.quote_id;
            },
            application_reference: function () {
                return this.$route.params.application_reference;
            },
            tabsToRender: function () {
                let vm = this, tabs = this.jsonCopy(this.portal_tabs);
                tabs.forEach((obj, index) => {

                    //if application is submitted, disabled steps 1-3 and mark them as complete.
                    //quote has been converted and application created
                    if (vm.isConvertedQuote && vm.isLockedQuote) {
                        //if quote is converted, set step one to is_complete.
                        if (obj.is_quote_tab) {
                            obj.is_complete = true;
                        }
                        if ((obj.is_application_tab && !vm.isOpenApplication)) {
                            obj.is_complete = true;
                            // obj.is_active = false; //TODO we need to rethink what it will act like when it's completed.
                        }
                    }
                    let signer_has_to_upload_id_document = vm.isSignerUser && !!vm.merchant_user_access &&
                        vm.merchant_user_access.hasOwnProperty('signer_to_upload_document') && vm.merchant_user_access.signer_to_upload_document;

                    if (obj.url === 'upload_documents') {
                        obj.display = vm.isMerchantViewAndUpdateDocument(vm.unfinished_application) || signer_has_to_upload_id_document;
                    }
                    else if (obj.url === 'documents') {
                        obj.display = !(vm.isMerchantViewAndUpdateDocument(vm.unfinished_application)) && !signer_has_to_upload_id_document;
                    }

                    if (obj.is_quote_tab) {
                        obj.url = vm.quote_root_path + obj.url;
                    } else {
                        obj.url = vm.application_root_path + obj.url;
                    }

                    // Disable tab if the path has 'add' to avoid navigation when data still loading
                    // The step 1 can be disabled because there's no navigation when creating a new application
                    let quote_path_has_add = vm.quote_root_path.includes('add');
                    let application_path_has_add = vm.application_root_path.includes('add');
                    if (quote_path_has_add || application_path_has_add) {
                        obj.is_active = false;
                    }
                });

                return tabs;
            },
        },
        methods: {
            ...mapActions(useApplicationStore, [types.FETCH_APPLICATION_PARAMETERS,
                types.COMMIT_QUOTE,
                types.FETCH_QUOTE_DATA,
                types.FETCH_APPLICATION_DATA]),
            ...mapActions(useApplicationStore, [types.SET_QUOTE_LOCK, types.SET_QUOTE_ROOT_PATH, types.SET_APPLICATION_ROOT_PATH]),

            fetchQuoteData: async function (quote_external_id) {
                if(quote_external_id === '' || typeof quote_external_id === 'undefined') {
                    //get quote data for first quote in merchant user_access
                    quote_external_id = this.merchant_user_access.quote[0]['quote_external_id'];
                }
                let payload = {
                    'user_external_id': this.user.user_external_id,
                    'quote_external_id': quote_external_id,
                }

                //fetch and commit Quote Data
                await this[types.FETCH_QUOTE_DATA](payload);

                this.setQuoteRootPath(quote_external_id, 'view')
                let quote_data = !!this.merchant_user_access && !!this.merchant_user_access.quote ? this.merchant_user_access.quote.find(obj => {
                    return obj.quote_external_id === quote_external_id
                }) : {}

                let application = !!this.merchant_user_access && this.merchant_user_access.hasOwnProperty('application') && !!quote_data && quote_data.hasOwnProperty('application_external_id') ? this.merchant_user_access.application.find(obj => {
                    return obj.application_external_id === quote_data.application_external_id
                }) : {};

                if (!!application && application.hasOwnProperty('application_reference') && !!application.application_reference) {
                    this.setApplicationRootPath(application.application_reference)

                    //fetch application when on step 1 pages
                    if (!this.merchant.hasOwnProperty('application_reference') || this.merchant.application_reference === '') {
                        this.fetchApplicationData(application.application_reference)
                    }
                }
            },
            fetchApplicationData: function (application_reference) {
                if (application_reference !== '' && typeof application_reference !== 'undefined') {

                    let payload = {
                        application_reference: application_reference,
                    }

                    //if the entry is from an application/ and we don't have quote get quote
                    if (!this.objectIsNotEmpty(this.quote) && this.merchant_user_access.hasOwnProperty('application')){
                        let application_data  = this.merchant_user_access.application.find(obj => {
                            return obj.application_reference === application_reference
                        });
                    }

                    //fetch and commit Application
                    this[types.FETCH_APPLICATION_DATA](payload).then(obj => {
                        this.setApplicationRootPath(application_reference);
                    }).then(obj => {
                        //there's a refetchQuoteData in review/index that gets the quote before this one
                        // so we have this check to prevent double fetching.
                        if (!this.objectIsNotEmpty(this.quote)) {
                            this.fetchQuoteData(this.merchant.quote_external_id);
                        }
                        this.setQuoteRootPath(this.merchant.quote_external_id, 'view');
                    });
                }
            },

        },
        watch: {
            "$route.params.quote_id": {
                handler: function (val, oldVal) {
                    if (val !== '' && typeof val !== 'undefined' && val !== this.quote.quote_external_id) {
                        this.fetchQuoteData(val);
                    }
                }
            },
            "$route.params.application_reference": {
                handler: function (val, oldVal) {
                    if (val !== '' && typeof val !== 'undefined' && val !== this.merchant.application_reference) {
                        this.fetchApplicationData(val)
                    }
                }
            },
        }
    }
</script>

<style scoped>

</style>